import { Component, computed, input } from '@angular/core';
import { NetzzuordnungIdImportReport } from '../model/netzzuordnung-id-import-report';
import { KeyValuePipe } from '@angular/common';
import { NzIdErrorCodeReadablePipe } from '../nz-id-error-code-readable.pipe';
import { NzIdWarningCodeReadablePipe } from '../nz-id-warning-code-readable.pipe';
import { LogItem } from '../model/log-item';

@Component({
    selector: 'tnb-importreport-display',
    standalone: true,
    imports: [
        NzIdErrorCodeReadablePipe,
        NzIdWarningCodeReadablePipe,
        KeyValuePipe,
    ],
    templateUrl: './import-report-display.component.html',
    styleUrls: [
        './import-report-display.component.scss',
    ],
})
export class ImportReportDisplayComponent {

    netzzuordnungIdImportReport = input<NetzzuordnungIdImportReport>();

    protected errorCodeCounts = computed(() => {
        return this.calculateCodeCounts(true);
    });

    protected warningCodeCounts = computed(() => {
        return this.calculateCodeCounts(false);
    });
    protected numberOfTransformationErrors = computed(() => {
        return this.netzzuordnungIdImportReport().log.filter(l => this.isError(l)).length;
    });
    protected numberOfTransformationWarnings = computed(() => {
        return this.netzzuordnungIdImportReport().log.filter(l => this.isWarning(l)).length;
    });
    protected areLogsPresent = computed(() => {
        return !!this.numberOfTransformationErrors() || !!this.numberOfTransformationWarnings();
    });
    protected readonly MAX_ITEMS = 100;
    protected isAmountOfErrorItemsToHigh = computed(() => {
        return this.netzzuordnungIdImportReport().log.length > this.MAX_ITEMS;
    });

    constructor() {
    }

    protected isError(logItem: LogItem): boolean {
        return logItem.type === 'ErrorImportNetzzuordnungIdLogItem';
    }

    protected isWarning(logItem: LogItem): boolean {
        return logItem.type === 'WarningImportNetzzuordnungIdLogItem';
    }

    private calculateCodeCounts(isError: boolean): { [p: string]: number } {
        const codes: { [p: string]: number } = {};
        const key = isError ? 'errorCode' : 'warningCode';
        for (const logEntry of this.netzzuordnungIdImportReport().log) {
            if (logEntry[key]) {
                const code = logEntry[key];
                codes[code] = codes[code] ?? 0;
                codes[code]++;
            }
        }

        return codes;
    }
}
